export default {
  labels: {
    custom: 'Custom - Auf Anfrage erhältich',
    was: 'Vorher {{amount}} – Jahresrabatt angewendet',
  },
  tags: {
    preferred: 'Besonders beliebt',
    net_one_time: 'netto einmalig',
    annual_discount: '-{{percentage}}% jährlich',
  },
  buttons: {
    select_plan: 'Wählen diesen Plan',
  },
};
